import { Login } from "shared/auth/login";
import { CenteredContainer } from "components/centeredContainer";
import { useToast } from "shared/toast/useToast";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "shared/i18n/useTranslation";
import { useUser } from "shared/auth/user/context";
export default function LoginPage() {
  const { translate } = useTranslation();
  const { error } = useToast();
  const navigate = useNavigate();
  const { setUser } = useUser();

  function handleSuccess({ data: user }) {
    setUser(user);
    navigate("/site/survey/list");
  }

  function handleError() {
    error(translate("__yourEmailOrPasswordIsWrong"));
  }
  return (
    <CenteredContainer>
      <Login handleError={handleError} handleSuccess={handleSuccess} />
    </CenteredContainer>
  );
}
